import { Console } from './components/console/Console'
import { GuestSite } from './components/GuestSite'
import { readRoute } from './routing'

/**
 * There are exactly two pages and no navigation between them, so the route is
 * read once rather than pulling in a router. See routing.ts for how a bare
 * `/{code}` is told apart from a page of ours.
 *
 * The two are entirely separate: the console never mounts the guest session hook
 * and vice versa, so being signed into one has no bearing on the other. The
 * server keeps them apart too - different cookies, different signing keys.
 */
export function App() {
  const route = readRoute()
  return route.page === 'console' ? <Console /> : <GuestSite codeFromLink={route.code} />
}
